module.exports = __webpack_public_path__ + "img/payment-method-cheque.edef0c48.png";